// src/components/Fast.js
import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import fast from "../assets/holypicture.jpg";
import Navbar from "../features/Navbar";
import Footer from "../components/Footer";
import useDevo from "../hooks/useDevo";

function Fast() {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [isAlternative, setIsAlternative] = useState(false);
  const { todayDevotional, loading, error } = useDevo(selectedDate, isAlternative);

  return (
    <div className="flex flex-col min-h-screen bg-gray-100">
      <Navbar />
      <main className="flex-grow container mx-auto px-4 sm:px-6 lg:px-12 py-6">
        <div className="flex justify-center mb-4">
          <button
            onClick={() => setIsAlternative(!isAlternative)}
            className="px-4 py-2 bg-blue-600 text-white rounded-md shadow-md hover:bg-blue-700"
          >
            {isAlternative ? "Switch to English Devotional" : "Switch to Yoruba Devotional"}
          </button>
        </div>
        {loading ? (
          <p className="text-center text-gray-800">Loading devotional...</p>
        ) : error ? (
          <p className="text-center text-red-500">{error}</p>
        ) : !todayDevotional ? (
          <div className="flex flex-col items-center mt-4">
            <p className="text-lg font-bold text-gray-800 text-center">
              No devotional available for the selected date.
            </p>
            <DatePicker
              selected={selectedDate}
              onChange={(date) => setSelectedDate(date)}
              className="mt-4 p-2 bg-gray-300 border rounded-md text-blue-900"
            />
          </div>
        ) : (
          <div className="flex flex-col items-center w-full">
            <div
              className="relative w-full h-[300px] sm:h-[400px] rounded-lg shadow-lg flex items-center justify-center bg-cover bg-center text-white"
              style={{ backgroundImage: `url(${fast})` }}
            >
              <div className="absolute inset-0 bg-black bg-opacity-50"></div>
              <div className="absolute top-4 left-4 flex">
                <DatePicker
                  selected={selectedDate}
                  onChange={(date) => setSelectedDate(date)}
                  className="p-2 bg-gray-300 border rounded-md text-blue-900"
                />
              </div>
              <div className="relative mt-[64px] flex flex-col items-center text-center w-full py-6 px-4 sm:px-10">
                <h2 className="text-xl sm:text-2xl font-bold shadow-md mt-4">
                  {todayDevotional.title}
                </h2>
                <p className="mt-2 text-sm sm:text-base">{todayDevotional.text}</p>
              </div>
            </div>
            <div className="w-full mt-6 px-4 sm:px-8 lg:px-16">
              <div>
                <h3 className="text-lg sm:text-xl font-bold text-gray-900">Message</h3>
                <p className="text-gray-700 mt-2 text-sm sm:text-base">
                  {todayDevotional.content}
                </p>
              </div>
              <div className="flex flex-wrap mt-4 mb-4">
                <span className="font-bold text-gray-900 mr-2 text-sm sm:text-base">
                  Bible Reading:
                </span>
                <span className="text-gray-900 text-sm sm:text-base">
                  {todayDevotional.bible_reading}
                </span>
              </div>
              <div className="mb-4">
                <h3 className="text-lg sm:text-xl font-bold text-gray-900">Prayer</h3>
                <p className="text-gray-700 mt-2 text-sm sm:text-base">
                  {todayDevotional.prayer}
                </p>
              </div>
              <p className="text-center text-base sm:text-lg font-bold text-gray-900 mt-4">
                AMEN!
              </p>
            </div>
          </div>
        )}
      </main>
      <Footer />
    </div>
  );
}

export default Fast;
